module.exports = __webpack_public_path__ + "static/media/Logo.dbce41df.png";